export default {
    path: 'paihuo_project',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/paihuo/ProjectList'),
    meta: {title:'项目审核'},
	children: [{
			path: '/paihuo_project/info',
			component: () => import('@/pages/paihuo/ProjectInfo'),
			meta: {
				title: '项目详情'
			},
		}
	]
}